// Popover scroll management
function managePopoverScroll() {
  const popovers = document.querySelectorAll('[popover]');

  popovers.forEach(popover => {
    // Listen for popover state changes
    popover.addEventListener('toggle', (event) => {
      requestAnimationFrame(() => {
        if (event.newState === 'open') {
          document.body.classList.add('noScroll');
        } else {
          document.body.classList.remove('noScroll');
        }
      });
    });
  });
}

function formatMoney(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || "${{amount}}");

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



function cartQuantity() {
  const quantitySelectors = document.querySelectorAll('.js-cart-item-quantity');

  quantitySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.js-cart-item-decrease');
    const plusBtn = selector.querySelector('.js-cart-item-increase');
    const quantityInput = selector.querySelector('.quantity-value');

    if (minusBtn && plusBtn && quantityInput) {
      let currentQuantity = parseInt(quantityInput.value) || 1;
      const maxQuantity = parseInt(quantityInput.getAttribute('max')) || Infinity;

      // Update quantity display
      function updateQuantity() {
        quantityInput.value = currentQuantity;

        // Disable minus button if quantity is 1
        minusBtn.disabled = currentQuantity <= 1;

        // Disable plus button if quantity is at max
        plusBtn.disabled = currentQuantity >= maxQuantity;

        // Trigger change event to notify Cart class
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Minus button click handler
      minusBtn.addEventListener('click', function () {
        if (currentQuantity > 1) {
          currentQuantity--;
          updateQuantity();
        }
      });

      // Plus button click handler
      plusBtn.addEventListener('click', function () {
        if (currentQuantity < maxQuantity) {
          currentQuantity++;
          updateQuantity();
        }
      });
    }
  });
}

function miniCartUpsellVariantSelect() {
  const upsell = document.querySelectorAll('.mini-cart-upsell .cart-upsell-product');
  upsell.forEach(upsell => {
    const upsellSelector = upsell.querySelector('.mini-cart-upsell-select');
    const upsellPrice = upsell.querySelector('.js-upsell-price');
    const upsellComparePrice = upsell.querySelector('.js-upsell-compare-at-price');

    upsellSelector.addEventListener('change', function () {
      const selectedVariantPrice = upsellSelector.selectedOptions[0].dataset.price;
      const selectedVariantComparePrice = upsellSelector.selectedOptions[0].dataset.comparePrice;
      // Update main price displays
      upsellPrice.innerHTML = formatMoney(selectedVariantPrice, window.theme.moneyFormat);
      upsellComparePrice.innerHTML = formatMoney(selectedVariantComparePrice, window.theme.moneyFormat);

      // Handle sale price display
      if (selectedVariantComparePrice != null) {
        upsellPrice.classList.add('sale');
        upsellComparePrice.classList.remove('hidden');
        upsellComparePrice.innerHTML = formatMoney(selectedVariantComparePrice, window.theme.moneyFormat);
      } else {
        upsellComparePrice.classList.add('hidden');
        upsellPrice.classList.remove('sale');
      }
    });
  });
}

function checkCartUpsell() {
  const upsellItemHandle = sessionStorage.getItem('miniCartUpsell');
  if (upsellItemHandle) {
    const cartUpsellItem = document.querySelector(`.cart-item[data-handle="${upsellItemHandle}"]`);

    if (cartUpsellItem) {
      document.body.classList.add('has-cart-upsell');
    } else {
      document.body.classList.remove('has-cart-upsell');
      sessionStorage.removeItem('miniCartUpsell');
    }
  }
}

managePopoverScroll();
cartQuantity();
miniCartUpsellVariantSelect();
checkCartUpsell();

cartFunction = function () {
  class Cart {
    triggers = {
      "click": {
        '[data-cart-remove]': 'handleRemove',
        '[data-cart-add]': 'handleAdd',
      },
      "change": {
        '[data-cart-quantity]': 'handleQuantity',
      }
    };

    constructor() {
      this.initHandlers()
    }

    initHandlers() {
      for (const [event, trigger] of Object.entries(this.triggers)) {
        document.addEventListener(event, function (e) {
          for (const [key, value] of Object.entries(this.triggers[e.type])) {
            var target = e.target.closest(key)
            if (target) {
              this[value](e, target);
            }
          }
        }.bind(this))
      }
    }

    toggleCart(action) {
      let cartBtn = document.querySelector('[data-cart-btn]');
      if (!cartBtn) {
        return;
      }
      let cartStatus = cartBtn.getAttribute('aria-expanded') === 'true' ? true : false;

      if (action == "open" && !cartStatus) {
        cartBtn.click();
      } else if (action == "close" && cartStatus) {
        cartBtn.click();
      }

      if (action == null) {
        cartBtn.click();
      }

      let productQuickView = document.querySelector('.product-quick-view-dialog[open]');

      if (productQuickView) {
        setTimeout(() => {
          productQuickView.close();
        }, 300);
      }
    };

    startLoading() {
      const target = document.querySelectorAll('[data-cart-contents]')
      target.forEach(el => {
        el.style.pointerEvents = 'none';
        el.style.opacity = 0.5;
      });
    }

    endLoading() {
      const target = document.querySelectorAll('[data-cart-contents]')
      target.forEach(el => {
        el.style.pointerEvents = 'auto';
        el.style.opacity = 1;
      })
    }

    updateSummary(data, action = null) {
      if (data.total_discount > 0) {
        document.querySelectorAll('.js-cart-discount').forEach(row => {
          if (row.classList.contains('hidden')) {
            row.classList.remove('hidden');
          }
        });
      } else {
        document.querySelectorAll('.js-cart-discount').forEach(row => {
          if (!row.classList.contains('hidden')) {
            row.classList.add('hidden');
          }
        });
      }

      if (data.item_count > 0) {
        document.querySelectorAll('[data-cart-empty]').forEach(cartEmpty => cartEmpty.remove());
        document.querySelectorAll('[data-cart-hidden]').forEach(cartHidden => cartHidden.classList.remove('hidden'));
      } else {
        document.querySelectorAll('[data-cart-contents]').forEach(cartContents => {
          if (!cartContents.querySelector('[data-cart-empty]')) {
            cartContents.insertAdjacentHTML("afterbegin", '<p class="block text-center text-sm" data-cart-empty>' + window.cartLang.emptyCart + '</p>');
          }
        });
        document.querySelectorAll('[data-cart-hidden]').forEach(cartHidden => cartHidden.classList.add('hidden'));
      }

      let cartKeyData = {
        '[data-cart-item-count]': data.item_count,
        '[data-cart-subtotal]': formatMoney(data.original_total_price, window.theme.moneyFormat),
        '[data-cart-discount]': formatMoney(data.total_discount, window.theme.moneyFormat),
        '[data-cart-total]': data.total_price,
      };
      for (const [key, value] of Object.entries(cartKeyData)) {
        document.querySelectorAll(key).forEach(item => {
          if (item.hasAttribute("data-cart-total")) {
            item.setAttribute('data-cart-total', value)
            item.innerHTML = formatMoney(value, window.theme.moneyFormat)
          } else {
            item.innerHTML = value;
          }
        });
      }

      if (document.body.classList.contains('template-cart')) {
        const mattressUpsell = document.querySelector('.cart-mattress-upsell'),
          headboardUpsell = document.querySelector('.cart-headboard-upsell');

        // Check if any items are mattress or headboard
        var hasMattress = false;
        var hasHeadboard = false;

        for (const item of data.items) {
          const downcaseItemTitle = item.title.toLowerCase();
          if (downcaseItemTitle.includes('mattress')) {
            hasMattress = true;
          }
          if (downcaseItemTitle.includes('headboard')) {
            hasHeadboard = true;
          }
        }

        if (hasMattress == true) {
          if (mattressUpsell) {
            mattressUpsell.classList.add('hidden');
          }
        } else {
          if (mattressUpsell) {
            mattressUpsell.classList.remove('hidden');
          }
        }

        if (hasHeadboard == true) {
          if (headboardUpsell) {
            headboardUpsell.classList.add('hidden');
          }
        } else {
          if (headboardUpsell) {
            headboardUpsell.classList.remove('hidden');
          }
        }

        if (hasMattress == true && hasHeadboard == true) {
          if (document.querySelector('.cart-page-upsell')) {
            document.querySelector('.cart-page-upsell').classList.add('hidden');
          }
        } else {
          if (document.querySelector('.cart-page-upsell')) {
            document.querySelector('.cart-page-upsell').classList.remove('hidden');
          }
        }
      }
    }

    fetchCartContents() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
          this.updateSummary(data);
        })
    }

    refreshCart(cartState) {
      fetch(window.Shopify.routes.root + 'cart?view=ajax')
        .then(response => response.text())
        .then(data => {
          document.querySelectorAll('[data-cart-contents]').forEach(cartContent => {
            cartContent.innerHTML = data;
          });
          checkCartUpsell();
          // Re-initialize cart quantity controls after content refresh
          cartQuantity();
          // Re-initialize mini cart upsell variant select after content refresh
          miniCartUpsellVariantSelect();
          // Re-initialize cart edit functionality after content refresh
          this.initializeCartEdit();
          if (cartState !== null) {
            this.toggleCart(cartState);
          }
        });
    }

    removeProduct(itemKey) {
      let element = document.querySelector(`.cart-item[data-cart-key-id="${itemKey}"]`);
      if (element) {
        element.remove();
      }
    }

    updateCart(itemKeys, quantity, callback = null) {
      var formData = { updates: {} };

      let keysArray = Array.isArray(itemKeys) ? itemKeys : [itemKeys];
      let quantityArray = Array.isArray(quantity) ? quantity : [quantity];

      if (quantityArray.length === 1 && keysArray.length > 1) {
        quantityArray = Array(keysArray.length).fill(quantityArray[0]);
      }

      keysArray.forEach((itemKey, index) => {
        formData.updates[itemKey] = quantityArray[index];
      });

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          if (callback !== null) {
            callback(data)
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    handleRemove(event, element) {
      event.preventDefault();

      let itemKey = element.getAttribute('data-key');
      let itemVariantId = element.getAttribute('data-variant-id');
      this.startLoading(true);
      this.updateCart(itemKey, 0, async function (response) {
        await this.updateUpsell();
        this.updateSummary(response);
        this.refreshCart('open');
        this.removeProduct(itemKey);

        let cartServiceWrapper = document.querySelector(`.service-block[data-variant-id="${itemVariantId}"]`);
        let cartService = document.querySelector(`.service-block__checkbox[data-variant-id="${itemVariantId}"]`);
        if (cartService) {
          cartServiceWrapper.classList.remove('hidden');
          cartService.checked = false;
        }

        this.endLoading();
      }.bind(this))
    }

    handleQuantity(event, element) {
      let itemKey = (element.closest('.cart-item').getAttribute('data-cart-key-id'));
      this.startLoading();
      let quantity = element.value

      this.updateCart(itemKey, quantity, function (response) {
        this.updateSummary(response);
        this.refreshCart('open');
        this.endLoading();
      }.bind(this))
    }

    handleAdd(event, element) {
      // Get the form that contains the clicked button
      const form = element.closest('form');
      let formData = new FormData(form);

      let formbutton = form.querySelector('[data-cart-add]');
      let formSubmit = form.querySelector('[data-cart-add] .btn-add-to-cart-text');
      let initialFormSubmitText = formSubmit.textContent;

      let formSubmitText = formbutton.querySelectorAll('.btn-add-to-cart-text');

      if (formbutton.classList.contains('btn-upsell')) {
        formSubmitText.forEach(text => {
          text.textContent = window.custom_product.adding;
        });
      } else {
        formSubmitText.forEach(text => {
          text.textContent = window.custom_product.addingToCart;
        });
      }

      let miniCartUpsell = event.target.closest('.mini-cart-upsell'),
        productCard = event.target.closest('.product-card');

      if (miniCartUpsell && productCard) {
        sessionStorage.setItem('miniCartUpsell', productCard.dataset.handle);
      }

      let itemIndex = 0;

      if (formbutton.classList.contains('btn-main-add-to-cart')) {
        //
        //  LM: Upsell - Mattress
        //
        const mattressUpsell = document.querySelector('.selected-mattress-upsell');
  if (mattressUpsell) {
      const mattressVariantId = mattressUpsell.getAttribute('data-variant-id');
      const mattressQuantity = mattressUpsell.getAttribute('data-variant-quantity');                                                  
      const mattressTitle = document.querySelector('.product__block--product_title h1').textContent;
                                                                                                                                      
      if (mattressVariantId && mattressQuantity && mattressTitle) {                                                                   
          formData.append(`items[${itemIndex}][id]`, mattressVariantId);
          formData.append(`items[${itemIndex}][quantity]`, mattressQuantity);                                                         
          itemIndex++;  // <-- FIXED: only increment when item was actually added
      }                                                                                                                               
  }


        //
        //  LM: Upsell - Headboard
        //
        const headboardUpsell = document.querySelector('.selected-headboard-upsell');
        if (headboardUpsell) {
          const headboardVariantId = headboardUpsell.getAttribute('data-variant-id');
          const headboardQuantity = headboardUpsell.getAttribute('data-variant-quantity');
          const headboardTitle = document.querySelector('.product__block--product_title h1').textContent;
          const selectedColour = document.querySelector('.product-colour-option-wrapper .selected-option').textContent;

          if (headboardVariantId && headboardQuantity && headboardTitle) {
            formData.append(`items[${itemIndex}][id]`, headboardVariantId);
            formData.append(`items[${itemIndex}][quantity]`, headboardQuantity);
            formData.append(`items[${itemIndex}][properties][Fabric Colour]`, selectedColour);
            itemIndex++;                                                                                                            
          }                                                    
        }  
      }  
       
        setTimeout(() => { 
        if (formbutton.classList.contains('btn-cart-upsell')) {
          const openUpsellClose = document.querySelector('.cart-upsell-popup:popover-open .cart-upsell-popup-overlay');
          const savingsClose = document.querySelectorAll('.savings-wrapper details[open] summary');

          if (openUpsellClose) {
            openUpsellClose.click();
          }
          savingsClose.forEach(close => close.click());
        }
      }, 1000);

      setTimeout(() => {
        if (formbutton.classList.contains('btn-cart-edit')) {
          const cartEditClose = document.querySelector('.cart-edit-popup:popover-open .cart-edit-popup-overlay');
          const cartEditKey = formbutton.getAttribute('data-key');

          if (cartEditClose) {
            cartEditClose.click();
          }

          if (cartEditKey) {
            const cartItem = document.querySelector('.cart-item[data-cart-key-id="' + cartEditKey + '"]');
            if (cartItem) {
              cartItem.querySelector('.cart-item-remove').click();
            }
          }
        }
      }, 1000);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(async data => {
          await this.updateUpsell();

          if (formbutton.classList.contains('btn-upsell')) {
            formSubmitText.forEach(text => {
              text.textContent = window.custom_product.added;
            });
          } else {
            formSubmitText.forEach(text => {
              text.textContent = window.custom_product.addedToCart;
            });
          }

          document.querySelectorAll('[data-cart-empty]').forEach(cartEmpty => cartEmpty.remove());
          this.refreshCart('open');
          this.fetchCartContents();

          setTimeout(function () {
            formSubmitText.forEach(text => {
              text.textContent = initialFormSubmitText;
            });
          }, 2000);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    async updateUpsell() {
      const oldCartUpsellProducts = document.querySelector('.mini-cart-upsell-contents'),
        miniCartUpsell = document.querySelector('.mini-cart-upsell');

      if (!oldCartUpsellProducts || !miniCartUpsell) {
        return;
      }

      const response = await fetch(window.location.origin);
      const data = await response.text();
      const newDocument = new DOMParser().parseFromString(data, 'text/html');
      const newCartUpsellProducts = newDocument.querySelector('.mini-cart-upsell-contents');
      const newMiniCartUpsellProduct = newCartUpsellProducts.querySelector('.product-card');

      oldCartUpsellProducts.replaceWith(newCartUpsellProducts);
      !!newMiniCartUpsellProduct && miniCartUpsell.reset();
    }

    initializeCartEdit() {
      if (typeof window.initializeServiceBlockFunctionality === 'function') {
        window.initializeServiceBlockFunctionality();
      }
    }
  }
  return new Cart()
}

cartFunction();

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.actions = this.querySelectorAll('*:is(input, select, button:not([type="submit"]), textarea, .card-action)');

    this.actions.forEach(action => {
      action.addEventListener('click', (e) => {
        e.preventDefault();
      });
    });
  }
}

customElements.define('product-card', ProductCard);

// Cookie consent overlay management
function manageCookieConsentOverlay() {
  const consentContainer = document.querySelector('.cky-consent-container');
  const overlay = document.querySelector('.cky-overlay');

  if (consentContainer && overlay) {
    // Check if consent container does NOT have the 'cky-hide' class
    if (!consentContainer.classList.contains('cky-hide')) {
      // Remove 'cky-hide' class from overlay
      overlay.classList.remove('cky-hide');
    }
  }
}

// Wait for cookie consent elements to be dynamically loaded
function waitForCookieConsentElements() {
  let attempts = 0;
  const maxAttempts = 50; // Stop after 5 seconds (50 * 100ms)

  const checkForElements = () => {
    const consentContainer = document.querySelector('.cky-consent-container');
    const overlay = document.querySelector('.cky-overlay');

    if (consentContainer && overlay) {
      manageCookieConsentOverlay();

      // Set up a MutationObserver to watch for class changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            manageCookieConsentOverlay();
          }
        });
      });

      // Observe changes to the consent container's class attribute
      observer.observe(consentContainer, {
        attributes: true,
        attributeFilter: ['class']
      });

      return; // Stop checking once elements are found
    }

    attempts++;
    if (attempts < maxAttempts) {
      // If elements not found, check again in 100ms
      setTimeout(checkForElements, 100);
    }
  };

  checkForElements();
}

document.addEventListener("DOMContentLoaded", function () {

  // Header wrapper height property

  const headerWrapper = document.querySelector('.header-group-wrapper');
  if (headerWrapper && headerWrapper.offsetHeight > 0) {
    document.body.style.setProperty('--header-group-height', headerWrapper.offsetHeight + 'px');
  }

  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }

  // Initialize cookie consent overlay management
  waitForCookieConsentElements();

  // Add .is-sticky class to announcement bar when it becomes sticky
  function handleAnnouncementBarSticky() {
    const announcementBars = document.querySelectorAll('.announcement-bar');
    announcementBars.forEach(bar => {
      const section = bar.closest('.shopify-section');
      if (section && !document.body.classList.contains('template-product')) {
        const rect = section.getBoundingClientRect();
        const isSticky = rect.top <= 0 && window.getComputedStyle(section).position === 'sticky';
        requestAnimationFrame(() => {
          if (isSticky) {
            bar.classList.add('is-sticky');
          } else {
            bar.classList.remove('is-sticky');
          }
        });
      }
    });
  }

  // Check on scroll and resize
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        handleAnnouncementBarSticky();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  requestAnimationFrame(() => {
    handleAnnouncementBarSticky(); // Initial check
  });

  // Add .btn__content wrapper to button children when loading state is added
  function wrapButtonContent() {
    document.querySelectorAll('.btn.loading-spinner').forEach(btn => {
      // Check if content is already wrapped
      if (btn.querySelector('.btn__content')) return;
      
      // Wrap all direct children in .btn__content
      const children = Array.from(btn.childNodes);
      if (children.length > 0) {
        const wrapper = document.createElement('span');
        wrapper.className = 'btn__content';
        // Move all nodes (elements and text) into wrapper
        // Use a document fragment to avoid reflow issues
        const fragment = document.createDocumentFragment();
        children.forEach(child => {
          fragment.appendChild(child);
        });
        wrapper.appendChild(fragment);
        btn.appendChild(wrapper);
      }
    });
  }

  // Watch for buttons getting loading-spinner class (removed one-time setup, MutationObserver handles dynamic content)
  if ('MutationObserver' in window) {
    const buttonObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('btn') && target.classList.contains('loading-spinner')) {
            wrapButtonContent();
          }
        }
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && node.classList.contains('btn') && node.classList.contains('loading-spinner')) {
              wrapButtonContent();
            }
          });
        }
      });
    });
    
    buttonObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }

});

